import React, { useCallback, useState } from 'react'

import {
  Button,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Stack,
} from '@chakra-ui/react'
import type { components } from 'src/lib/api-client/schema.gen'
import { ModalCancelButton } from 'src/lib/chakra-theme/components'

const useChangeTemplateFolderName = (initialName: string) => {
  const [templateFolderName, setTemplateFolderName] =
    useState<string>(initialName)
  const onChangeTemplateFolderName = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setTemplateFolderName(e.target.value)
    },
    [],
  )

  return { templateFolderName, onChangeTemplateFolderName }
}

type Props = {
  v2: boolean
  observationType: components['schemas']['enums.ObservationType']
  initialName: string
  requesting: boolean

  onClose: () => void
  onSubmit: (name: string) => void
}

export const EditModal: React.FC<Props> = props => {
  const { templateFolderName, onChangeTemplateFolderName } =
    useChangeTemplateFolderName(props.initialName)

  const onSubmit = useCallback(() => {
    props.onSubmit(templateFolderName)
  }, [props, templateFolderName])

  const canSubmit = !props.requesting && !!templateFolderName

  return (
    <Modal onClose={props.onClose} isOpen>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalHeader>フォルダ名を編集</ModalHeader>

        <ModalBody>
          <Stack spacing="3" pt={1}>
            <Input
              value={templateFolderName}
              onChange={onChangeTemplateFolderName}
            />
            {props.v2 && (
              <RadioGroup value={props.observationType} isDisabled>
                <Stack spacing="2" direction="row">
                  <Radio value="Visit">Visit</Radio>
                  <Radio value="FollowUp">
                    <Flex gap="1.5" align="center">
                      随時観察
                    </Flex>
                  </Radio>
                  <Radio value="DocumentExchange">指示</Radio>
                </Stack>
              </RadioGroup>
            )}
          </Stack>
        </ModalBody>

        <ModalFooter>
          <ModalCancelButton />
          <Button onClick={onSubmit} isDisabled={!canSubmit}>
            確定
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
